(function ($) {

    $(document).ready(function() {
        /**
         * Smooth scrolling (uses data-scroll="{{boolean}}")
         * TODO: make plain JS
         */
        $('a[data-scroll="true"]').click(function(e) {
            e.preventDefault();
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('body');
                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top
                    }, 300);
                }
            }
        });

        /**
         * Modals (because Bootstrap modals don't work for some ungodly reason)
         * jQuery for ease and speed of writing
         */
        (function() {
            var toggleModal = function(target, isOpen) {
            
                var documentBody = $('body'),
                    backdrop = '<div class="modal-backdrop fade"></div>';
    
                if (isOpen) {
                    backdrop = $('.modal-backdrop');
    
                    //begin animations
                    backdrop.removeClass('show');
                    target.removeClass('show').addClass('fade');
                    documentBody.attr('style', '');
                    
                    //when animations are done
                    setTimeout(function() {
                        target.attr('style', '');
                        backdrop.remove();
                    }, 310);
                } else {
                    documentBody.append(backdrop).attr('style', 'height: 100vh; overflow: hidden;');
                    target.attr('style', 'display: block;');
                    backdrop = $('.modal-backdrop');
    
                    //begin animations
                    setTimeout(function() {
                        backdrop.addClass('show');
                        target.removeClass('fade').addClass('show');
                    }, 10);
                }
            };
    
            $('[data-toggle="modal"]').on('click', function(e) {
                e.preventDefault();
                var openTarget = $($(this).data('target'));
    
                toggleModal(openTarget, false);
            });
    
            $('[data-dismiss="modal"]').on('click', function(e) {
                e.preventDefault();
                var dismissTarget = $('.modal.show');
    
                toggleModal(dismissTarget, true);
            });
    
            $('body').on('click', '.modal.show', function(e) {
                if (e.target == e.currentTarget) { //e.target is always what element is actually clicked on, currentTarget is the .modal.show element
                    var dismissTarget = $('.modal.show');
    
                    toggleModal(dismissTarget, true);
                }
            });
        })();
        
        /**
         * End modals
         */
    });
}(jQuery));